export default __webpack_public_path__ + "static/media/generic-error-icon.c65be0c2.svg";